/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {LinksData} from '../../core/_models'
import moment from 'moment'

type Props = {
  embeddings: LinksData
}

const UserJoinedDate: FC<Props> = ({embeddings}) => (
  <div className='d-flex align-items-center'>
    {/* begin:: Avatar */}

    <div className='d-flex flex-column'>{embeddings.characters}</div>
  </div>
)

export {UserJoinedDate}
